import axios from 'axios';

const axiosInstance = axios.create({
  baseURL: '/linker-api/',

  headers: {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${window.localStorage.getItem('token')}`,
  },
});

axiosInstance.interceptors.request.use(
  function (config) {
    // Do something before request is sent
    config.headers = {
      ...config.headers,
      ...{
        'Content-Type': 'application/json,multipart/form-data',
        Authorization: `Bearer ${window.localStorage.getItem('token')}`,
      },
    };
    return config;
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  },
);

// Add a response interceptor
axiosInstance.interceptors.response.use(
  function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return response;
  },
  function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    return Promise.reject(error);
  },
);

export default axiosInstance;
